import React from "react";
import { motion } from "framer-motion";

function Footer() {
  return (
    <footer className="relative bg-gradient-to-r from-[#001f3f] to-[#003366] text-white">
      {/* Background Glow */}
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_#00bfff,_transparent_40%)]"></div>

      <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between relative z-10">
        {/* ✅ Logo + SPK MAK  attach */}
        <motion.div
          className="flex items-center gap-3 self-start md:self-center"
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* Logo image from public folder */}
          <img
            src="/SPK _ MAK LOGO (2).jpg"
            alt="SPK MAK Logo"
            className="w-14 h-14 object-contain"
          />
          {/* Company Name */}
          <span className="text-xl md:text-2xl font-bold text-[#00bfff]">
            SPK MAK TECHNOLOGIES
          </span>
        </motion.div>

        {/* Footer Text */}
        <motion.p
          className="mt-4 md:mt-0 text-center md:text-right text-gray-300 text-sm"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          &copy; {new Date().getFullYear()} SPK MAK TECHNOLOGIES PRIVATE LIMITED.
          <br />All Rights Reserved 🚀
        </motion.p>
      </div>

      
    </footer>
  );
}

export default Footer;
